export interface PlanScheduleDay {
    weekDay: number;
    executionTime: string;
    timeZone: string;
}